{
  "id": "campaign-015",
  "name": "Wild Backyard",
  "seed": "campaign:15",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "HHH.........",
    "HHH.........",
    "___.........",
    "...,........",
    "..,,,..#....",
    "...,........",
    ".....,......",
    "....,,,x....",
    "____________",
    "............",
    ".h..h.,h,.h.",
    ".......,....",
    ".......#....",
    "S..........."
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 3,
      "y": 6
    },
    {
      "kind": "squirrel",
      "x": 6,
      "y": 13
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 10,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 10
    }
  ],
  "generatorVersion": 3,
  "level": 15,
  "biome": "backyard",
  "par": {
    "reel": 6282,
    "push": 4790,
    "selfPropelled": 4416,
    "tractor": 4020,
    "zeroTurn": 3052,
    "fairway": 1940
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 22,
      "zeroTurn": 19,
      "fairway": 13
    }
  }
}
